import React from 'react'
import { AchResponse } from './achResponse'

export const AchResponseAPI = () => {
  return (
    <AchResponse />
  )
}
